import React, { useState } from 'react'
import OnlinePkBanner from '../../../assets/images/front/online-pk-5-banner.png'
import OnlinePkBannerMobile from '../../../assets/images/front/online-pk-5-banner-mobile.png'
import OnlinePk5BannerGraphics from '../../../assets/images/front/svg/prezencne-pk-9-banner-graphics-2.svg'
import OnlinePk5BannerButton from '../../../assets/images/front/svg/prezencne-pk-9-button.svg'
import Image2250 from '../../../assets/images/front/2250.png'
import ImageHand from '../../../assets/images/front/ruka.png'
import ArrowWhiteRight from '../../../assets/images/front/svg/arrow-right-white.svg'
import ArrowDownRight from '../../../assets/images/front/svg/arrow-down-white.svg'
import ScheduleMobile from '../../../assets/images/front/svg/schedule-mobile.svg'
import Schedule from '../../../assets/images/front/svg/schedule.svg'
import Schedule2 from '../../../assets/images/front/svg/schedule-2.svg'
import Schedule3 from '../../../assets/images/front/svg/schedule-3.svg'
import Schedule4 from '../../../assets/images/front/svg/schedule-4.svg'
import SkolaBannerSecondary from '../../../assets/images/front/skola-banner-secondary.png'
import SkolaBannerSecondaryMobile from '../../../assets/images/front/skola-banner-secondary-mobile.png'
import { useHistory } from 'react-router-dom'
import { routesURLs } from '../../../Routes'
import { getSettings } from '../../../moduls/settings'
import { useQuery } from 'react-query'
import { Settings } from '../../../services/types'
import OwlBanner from '../../../components/Front/OwlBanner/OwlBanner'
import { getPersonalCoursesLocations } from '../../../moduls/personal-courses';


const Pk9: React.FC = () => {
  const history = useHistory()
  // Accordion state
  const [openAccordion, setOpenAccordion] = useState<number | null>(null)
  const [selectedSchool, setSelectedSchool] = useState<string>('vodickova')
  const { data: onsiteLocations = [], isLoading } = useQuery('onsite-courses', getPersonalCoursesLocations)

  const { data: settings } = useQuery<Settings>(['settings'], getSettings)

  const handleAccordionClick = (idx: number) => {
    setOpenAccordion(openAccordion === idx ? null : idx)
  }

  return (
    <>
      <div className="container relative mx-auto md:px-4 mt-[52px] lg:mt-[84px] mb-[30px] md:mb-[50px]">
        <img
          src={OnlinePkBanner}
          alt=""
          className="w-full min-h-[350px] h-auto hidden md:block object-cover rounded-b-3xl"
        />
        <img
          src={OnlinePkBannerMobile}
          alt=""
          className="w-full min-h-[350px] h-auto md:hidden object-cover"
        />
        <div className="absolute left-[50%] translate-x-[-50%] md:translate-x-0 md:left-8 top-4 w-[calc(100%-16px)] md:w-full px-4">
          <img
            src={OnlinePk5BannerGraphics}
            alt=""
            className="w-full max-w-[585px] h-auto object-cover"
          />
        </div>
        <div className="absolute right-[-50%] translate-x-[-50%] md:translate-x-0 bottom-10 md:right-20 md:bottom-20 flex md:block items-center justify-center w-full md:w-auto">
          <span
            onClick={() => history.push(routesURLs.personalCourses)}
            className="cursor-pointer inline-block text-2xl md:text-5xl pt-3 text-white bg-[#00A0E3] hover:bg-[#0183BA] tracking-wide leading-tight px-10 py-2 rounded-xl transition-colors duration-200 relative"
          >
            přihlásit se do kurzu
            <img
              src={OnlinePk5BannerButton}
              alt=""
              className="absolute top-[30%] translate-y-[-50%] -right-10 w-[100px] hidden md:block"
            />
            <img src={Image2250} alt="" className="absolute w-[60px] -top-10 -right-8 md:hidden" />
            <img
              src={ImageHand}
              alt=""
              className="absolute w-[60px] -bottom-9 left-[50%] translate-x-[-50%] md:hidden"
            />
          </span>
        </div>
      </div>
      <div className="bg-[#00A0E3] w-full py-8 mb-[30px] md:mb-[50px]">
        <h2 className="text-wrapper-16 mb-6 text-white text-center">aktuální termíny</h2>
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-12 gap-2 w-full max-w-[820px] mx-auto">
            {onsiteLocations.map((location) => (
            <div className="col-span-12">
              <div className="hidden md:flex flex-row items-center justify-between bg-white rounded-lg p-2 rounded-lg">
                <span className="text-lg text-[#0183BA]">
                  {location.name}
                </span>
                <a
                  href={routesURLs.personalCourses + '/' + location.city_id + '?locationId=' + location.id}
                  className="rounded-lg text-lg text-white leading-tight pt-1 px-3 bg-[#A8CD00]"
                >
                  VYBRAT TERMÍN
                </a>
              </div>
              <div className="flex md:hidden flex-col bg-white rounded-lg p-2 rounded-lg">
                <div className="mb-3">
                  <span className="text-lg text-[#0183BA]">
                    {location.name}
                  </span>
                </div>
                <div className="flex justify-between items-center">
                  <a
                    href={routesURLs.personalCourses + '/' + location.city_id + '?locationId=' + location.id}
                    className="rounded-lg text-lg text-white leading-tight pt-1 px-3 bg-[#A8CD00] ms-auto"
                  >
                    VYBRAT TERMÍN
                  </a>
                </div>
              </div>
            </div>
            ))}
          </div>
        </div>
      </div>
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-12 gap-4 mb-[30px] lg:mb-[50px]">
          <div className="col-span-12 lg:col-span-7">
            <div className="aspect-w-16 aspect-h-9 w-full h-full rounded-3xl overflow-hidden shadow-lg">
              <iframe
                src="https://player.vimeo.com/video/595899354"
                title="PK9 video"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
                className="w-full h-full"
              ></iframe>
            </div>
          </div>
          <div className="col-span-12 lg:col-span-5 py-6 px-8 bg-[#00A0E3] rounded-3xl text-white">
            <h3 className="text-white text-lg lg:text-[25px] leading-tight mb-5">Co nabízíme</h3>
            <ul className="font-myriad is-pure-list">
              <li className="flex items-start mb-1">
                <img src={ArrowWhiteRight} alt="" className="mt-1 me-1" />
                Komplexní přípravu na přijímací zkoušky
              </li>
              <li className="flex items-start mb-1">
                <img src={ArrowWhiteRight} alt="" className="mt-1 me-1" />
                Upevnění znalostí získaných na ZŠ
              </li>
              <li className="flex items-start mb-1">
                <img src={ArrowWhiteRight} alt="" className="mt-1 me-1" />
                Malé skupiny 10-15 žáků
              </li>
              <li className="flex items-start mb-1">
                <img src={ArrowWhiteRight} alt="" className="mt-1 me-1" />Z každé hodiny žák obdrží
                pracovní list domů
              </li>
              <li className="flex items-start mb-1">
                <img src={ArrowWhiteRight} alt="" className="mt-1 me-1" />
                Video záznam každé lekce kdykoliv k dispozici
              </li>
              <li className="flex items-start">
                <img src={ArrowWhiteRight} alt="" className="mt-1 me-1" />
                Osvědčené tipy a triky jak se vypořádat s problematickými úlohami
              </li>
              <li className="flex items-start">
                <img src={ArrowWhiteRight} alt="" className="mt-1 me-1" />
                Možnost absolvovat přijímačky nanečisto
              </li>
              <li className="flex items-start">
                <img src={ArrowWhiteRight} alt="" className="mt-1 me-1" />
                Při absenci studenta na lekci posíláme veškeré materiály v elektronické podobě
              </li>
              <li className="flex items-start">
                <img src={ArrowWhiteRight} alt="" className="mt-1 me-1" />
                Možnost nahradit lekci s jinou skupinou
              </li>
            </ul>
          </div>
          <div className="course-accordion col-span-12 md:col-span-6">
            <div
              className="cursor-pointer px-4 md:px-8 py-2 text-[25px] md:text-[50px] text-white bg-[#0183BA] hover:bg-[#016a96] transition-colors duration-300 rounded-xl md:rounded-3xl flex flex-col"
              onClick={() => handleAccordionClick(0)}
            >
              <div className="flex items-center justify-between">
                <span>Kurz 1 - 4 490 Kč</span>
                <img
                  src={ArrowDownRight}
                  className={`transition-transform duration-300 ${
                    openAccordion === 0 ? 'rotate-180' : ''
                  }`}
                  alt=""
                />
              </div>
              {openAccordion === 0 && (
                <div className="text-base text-white">
                  <p className="mb-3">
                    Tento kurz je zaměřený na vysvětlení a procvičení veškeré látky, která je
                    součástí osnov na základních školách. Zvýšenou pozornost věnujeme zejména
                    aplikaci těchto znalostí v úlohách, které se objevují v testech.
                  </p>
                  <p className="mb-3">
                    Veškeré učivo žákům podáváme co nejjednodušší formou v logicky navazujících
                    blocích. Kurz je vhodný pro žáky, kteří si potřebují utřídit a zopakovat látku
                    základní školy, jež je klíčová pro úspěšné zvládnutí přijímacího řízení. Po
                    absolvování kurzu budou vědět, co je u přijímaček čeká, a nic je u zkoušky
                    nezaskočí.
                  </p>
                  <p className="mb-3">
                    Harmonogram tvoří třináct devadesátiminutových lekcí (jedna lekce týdně) pro
                    každý předmět; začínáme v říjnu a končíme cca v polovině února. Lze jej
                    kombinovat s Kurzem 2, přičemž je možnost navštěvovat pouze část zaměřenou na
                    český jazyk nebo matematiku, či obě dvě části souběžně.
                  </p>
                  <p className="mb-3">
                    Cena za KURZ 1 - M + ČJ je 7 990 Kč. V případě přihlášení pouze na jeden předmět
                    (M / ČJ) je kurzovné 4 490 Kč.
                  </p>
                </div>
              )}
            </div>
          </div>
          <div className="course-accordion col-span-12 md:col-span-6">
            <div
              className="cursor-pointer px-4 md:px-8 py-2 text-[25px] md:text-[50px] text-white bg-[#0183BA] hover:bg-[#016a96] transition-colors duration-300 rounded-xl md:rounded-3xl flex flex-col"
              onClick={() => handleAccordionClick(1)}
            >
              <div className="flex items-center justify-between">
                <span>Kurz 2 - 2 290 Kč</span>
                <img
                  src={ArrowDownRight}
                  className={`transition-transform duration-300 ${
                    openAccordion === 1 ? 'rotate-180' : ''
                  }`}
                  alt=""
                />
              </div>
              {openAccordion === 1 && (
                <div className="text-base">
                  <p className="mb-3">
                    Tento kurz je zaměřený na vysvětlení a procvičení veškeré látky, která je
                    součástí osnov na základních školách. Zvýšenou pozornost věnujeme zejména
                    aplikaci těchto znalostí v úlohách, které se objevují v testech.
                  </p>
                  <p className="mb-3">
                    Veškeré učivo žákům podáváme co nejjednodušší formou v logicky navazujících
                    blocích. Kurz je vhodný pro žáky, kteří si potřebují utřídit a zopakovat látku
                    základní školy, jež je klíčová pro úspěšné zvládnutí přijímacího řízení. Po
                    absolvování kurzu budou vědět, co je u přijímaček čeká, a nic je u zkoušky
                    nezaskočí.
                  </p>
                  <p className="mb-3">
                    Harmonogram tvoří třináct devadesátiminutových lekcí (jedna lekce týdně) pro
                    každý předmět; začínáme v říjnu a končíme cca v polovině února. Lze jej
                    kombinovat s Kurzem 2, přičemž je možnost navštěvovat pouze část zaměřenou na
                    český jazyk nebo matematiku, či obě dvě části souběžně.
                  </p>
                  <p className="mb-3">
                    Cena za KURZ 1 - M + ČJ je 7 990 Kč. V případě přihlášení pouze na jeden předmět
                    (M / ČJ) je kurzovné 4 490 Kč.
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="container mx-auto px-4 mb-[30px] lg:mb-[50px]">
        <div className="grid grid-cols-12 gap-4">
          <div className="col-span-12">
            <label htmlFor="school-select" className="text-[#0183BA]">
              Zvolte školu
            </label>
            <select
              id="school-select"
              className="text-[#0183BA] border border-[#00A0E3] w-full p-2 rounded-lg"
              value={selectedSchool}
              onChange={(e) => setSelectedSchool(e.target.value)}
            >
              <option value="vodickova">ZŠ Vodičkova - Vodičkova 22 - Praha 2</option>
              <option value="stross">ZŠ Strossmayerovo náměstí - Praha 7</option>
              <option value="londynska">ZŠ Londýnská - Praha 2</option>
              <option value="vencliku">ZŠ Bratří Venclíků - Praha 13</option>
              <option value="beranku">ZŠ Na Beránku - Praha 12</option>
              <option value="bezrucova">ZŠ Bezručova - Říčany</option>
            </select>
          </div>
          <div className="col-span-12 hidden md:block">
            {selectedSchool === 'beranku' ? (
              <img src={Schedule2} alt="" className="w-full h-auto object-cover" />
            ) : selectedSchool === 'londynska' || selectedSchool === 'vencliku' ? (
              <img src={Schedule3} alt="" className="w-full h-auto object-cover" />
            ) : selectedSchool === 'bezrucova' ? (
              <img src={Schedule4} alt="" className="w-full h-auto object-cover" />
            ) : (
              <img src={Schedule} alt="" className="w-full h-auto object-cover" />
            )}
          </div>
          <div className="col-span-12 md:hidden">
            <img src={ScheduleMobile} alt="" className="w-full h-auto object-cover -mt-20" />
          </div>
        </div>
      </div>
      <div className="-mb-12">
        <div className="container relative mx-auto md:px-4">
          <img src={SkolaBannerSecondary} alt="" className="hidden md:block rounded-t-3xl" />
          <img src={SkolaBannerSecondaryMobile} alt="" className="block md:hidden rounded-t-3xl" />
          <div className="grid grid-cols-12 gap-4 absolute top-5 left-8 pe-8 md:left-[120px] md:top-[60px]">
            <div className="col-span-12 md:col-span-9 lg:col-span-6 flex flex-col text-center md:text-left">
              <h3 className="text-[25px] text-[#00A0E3] mb-3 md:mb-2">
                Nemůžete chodit na prezenční kurzy?
              </h3>
              <div className="mb-6 leading-tight text-[25px] text-[#0183BA]">
                Vyzkoušejte náš on-line kurz a<br className="hidden md:block" />
                připravte se z pohodlí domova!
              </div>
              <span
                onClick={() => history.push(routesURLs.pk9Online)}
                className="cursor-pointer inline-block text-white leading-tight text-[25px] bg-[#A8CD00] hover:bg-[#8FB200] rounded-xl pt-3 py-2 px-4 transition-colors duration-200 me-auto"
              >
                on-line kurzy pro 9. třídu
              </span>
            </div>
          </div>
        </div>
      </div>
      <OwlBanner settings={settings as Settings} />
    </>
  )
}

export default Pk9
